import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { SortOrder } from "interfaces/SortOrder";

export enum EExamTableStatus {
  PENDING = "Pending",
  QUICK_PASSED = "Quick Passed",
  EXAM_PASSED = "Exam Passed",
  EXAM_FAILED = "Exam Failed"
}

export interface IHeaderCell<T = string> {
  title: string;
  isDisplayed: boolean;
  dataTestId?: string;
  centered?: boolean;
  lastTwoColumnsCell?: boolean;
  lastOneColumnCell?: boolean;
  sortableCell?: {
    name: T;
    sortOrder: SortOrder;
    sortHandler: (columnName: T, sortOrder: SortOrder) => void;
    isInverted?: boolean;
  };
  highlighted?: boolean;
}

export enum ERowColumn {
  HORSE_AND_TRAINER = "horseAndTrainer",
  HISTORY = "history",
  WORK_DATE = "workDate",
  RISK_LEVEL = "riskLevel",
  BARN = "barn",
  STALL = "stall",
  EXAM_STATUS = "examStatus",
  CSA = "csa",
  HSF = "hsf",
  DLW = "dlw",
  DLR = "dlr",
  LAST_EXAM = "lastExam",
  ASSIGNED_VET = "assignedVet",
  UNASSIGN = "unAssign",
  EXAM = "exam",
  EXAM_TYPE = "examType",
  EXTENDER = "extender",
  RISK_FACTORS = "riskFactors",
  FLAG_REQUEST = "flagRequest",
  ACTIVE_VET_LISTS = "activeVetList",
  IMAGE_DIAGNOSTICS_REQUIRED = "imageDiagnostic",
  REQUESTED = "requested",
  RISK_FACTOR_SCORE = "riskFactorScore",
  RACE_DATE = "raceDate",
  RACE_NUMBER = "raceNumber",
  RACE_POSITION = "racePosition",
  RACE_TYPE = "raceType",
  WATCH_LIST = "watchList",
  ENTRY_REVIEW = "entryReview",
  RACE_DAY_REVIEW = "raceDayReview"
}

export enum EEventType {
  WORKOUT_REQUEST = "Workout Request",
  PRE_RACE = "Race"
}

export type TExamNote =
  | racehorse360.IWorkoutRequestExamReasonNote
  | racehorse360.IUpcomingRaceEntryExamNote;

export type TFlagPriority =
  | racehorse360.WorkoutRequestFlagPriority
  | racehorse360.UpcomingRaceEntryFlagPriority;

export interface IExamsTableRowData {
  eventId: string;
  eventType: EEventType;
  eventDate: string;
  eventNumber?: number;
  eventPosition?: number;
  eventCreationDate: string;
  eventStatus:
    | racehorse360.WorkoutRequestStatus
    | racehorse360.UpcomingRaceEntryStatus;
  eventFacility: racehorse360.IFacility;
  eventFlag?:
    | racehorse360.IWorkoutRequestFlag
    | racehorse360.IUpcomingRaceEntryFlag;
  hasEventComment?: boolean;
  hasEventRacingSecretaryComment?: boolean;
  pastEventsCount?: number;
  eventRejectionNote?: racehorse360.IWorkoutRequestRejectionComment;
  examId: string;
  examStatus: racehorse360.HorseExamStatus;
  examType: racehorse360.HorseExamType;
  examCreatedBy?: racehorse360.IUser;
  examResult?: racehorse360.HorseExamResult;
  examAssignedUser?: racehorse360.IUser;
  examNote?: TExamNote;
  examCompletedBy?: racehorse360.IUser;
  examCompletedOn?: string;
  raceDayExamConclusion?: string;
  horse?: racehorse360.IHorse;
  highSpeedFurlongs?: number;
  upcomingRace?: racehorse360.IUpcomingRace;
  classChange?: number;
  claimChange?: number;
}

export interface ITableHeaderColumnsContent<T = string> {
  [key: string]: IHeaderCell<T> | IHeaderCell<T>[];
}

export interface ITableColumnsContent {
  [key: string]: React.ReactNode;
}
